// Libraries
var React = require('react');

// Style
require('./BlockQuote.scss');

class BlockQuoteModule extends React.Component {
  render() {
    return (
      <div id={this.props.data.id} className={`c-section c-section--gutter${this.props.data.isPremium ? " c-section--premium" : ""}${this.props.data.alternate ? " c-section--alternate-blockquote" : ""}`}>
        <div className="c-section__inner">
          <blockquote className={`c-blockquote${this.props.data.isPremium ? " c-blockquote--premium" : ""}${this.props.data.alternate ? " c-blockquote--alternate" : ""}`}>
            <p className="c-blockquote__quote">{this.props.data.text}</p>
            <footer className="c-blockquote__footer">
              {(this.props.data.name !== '' || this.props.data.role !== '') &&
                <cite className="c-blockquote__cite">
                  {this.props.data.name !== '' &&
                    <span className="c-blockquote__name">{this.props.data.name}</span>
                  }
                  {this.props.data.role !== '' &&
                    <span className="c-blockquote__role">{this.props.data.role}</span>
                  }
                </cite>
              }
            </footer>
          </blockquote>
        </div>
      </div>
    );
  }
};

module.exports = BlockQuoteModule;


// WEBPACK FOOTER //
// ./src/components/BlockQuote/BlockQuote.js